import React from 'react';
import styles from "./BannerNews.module.scss"
import Container from "../Container/Container";
import TitleUnderline from "../TitleUnderline/TitleUnderline";
import DefaultButton from "../DefaultButton/DefaultButton";

const BannerNews = () => {
    return (
        <div className={styles.root}>
            <Container>
                <div className={styles.wrapper}>
                    <div className={styles.text}>
                        <TitleUnderline className={styles.title}>Новости и статьи</TitleUnderline>
                        <div className={styles.desc} >
                            Добро пожаловать в блог компании System Professional Line (SPL) — одного из ведущих производителей электротехнических и слаботочных решений в России. Мы занимаем лидирующие позиции на рынке кабеленесущих систем, предлагая высококачественные кабельные каналы, гофрированные трубы и компоненты для структурированных кабельных систем.

                            В нашем блоге мы делимся полезной и актуальной информацией, связанной с нашей продукцией, монтажом кабельных систем, новыми технологиями и решениями в области электромонтажа. Здесь вы найдете советы экспертов, новости индустрии и рекомендации по выбору оборудования, которые помогут вам реализовать ваши проекты качественно, безопасно и эффективно.
                        </div>
                    </div>
                    <img className={styles.img} src='images/sks-main-new.jpg' alt="модули"/>
                </div>
            </Container>
        </div>
    );
};

export default BannerNews;